import { createDataStore } from "./common";

export default createDataStore({
  storeKey: "countries",
  endpoint: process.env.REACT_APP_PLACES_API_HOST + "/countries",
  idKey: "mn_country_id"
});
